import React, { useEffect, useState } from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import caseStudyDetails from "../../data/caseStudyDetails.json";

const CaseStudyDetail = () => {
  const { title } = useParams();
  const [caseStudy, setCaseStudy] = useState(null);

  useEffect(() => {
    console.log(caseStudyDetails)
    const casestudyMeta = caseStudyDetails.find((b) => b.companyName.toLowerCase() === title.toLowerCase());
    setCaseStudy(casestudyMeta || null);
    window.scrollTo(0, 0); // optional: scroll to top on handle change
  }, [title]);

  return (
    <>
      <Helmet>
        <title>{caseStudy?.meta_title}</title>
        <meta name="description" content={caseStudy?.meta_description} />
      </Helmet>
      <div className="hidden sm:block">
        <Section1 />
      </div>
      <div className="bg-gray-100 ">
        <Section2 />
      </div>
    </>
  );
};

export default CaseStudyDetail;
